import { ClockOnlineLog, ClockOnlineStatus } from "../../../../../api/admin";
import {
  DSTable,
  DSTableHead,
  DSTableBody,
  DSTableRow,
  DSTableCell,
  DSTableContainer,
} from "../../../../system-design/Table";

const DeviceOnlineTable = ({ data }: { data: ClockOnlineLog[] }) => (
  <DSTableContainer sx={{ maxHeight: 400, marginTop: 2 }}>
    <DSTable size="small" stickyHeader>
      <DSTableHead>
        <DSTableRow>
          <DSTableCell>Status</DSTableCell>
          <DSTableCell>Start</DSTableCell>
          <DSTableCell>End</DSTableCell>
        </DSTableRow>
      </DSTableHead>
      <DSTableBody>
        {data.map((row, index) => (
          <DSTableRow key={index}>
            <DSTableCell
              sx={{
                color:
                  row.status === ClockOnlineStatus.ONLINE
                    ? "success.main"
                    : "error.main",
                fontWeight: 600,
              }}
            >
              {row.status}
            </DSTableCell>
            <DSTableCell>
              {new Date(row.period_start).toLocaleString()}
            </DSTableCell>
            <DSTableCell>
              {new Date(row.period_end).toLocaleString()}
            </DSTableCell>
          </DSTableRow>
        ))}
      </DSTableBody>
    </DSTable>
  </DSTableContainer>
);

export default DeviceOnlineTable;
